import { contains3ue2qo8xhmpf1 as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function maybeSafariOrIos() {
  var userAgent = window.navigator.userAgent;
  var isSafari = contains(userAgent, 'Safari', true) && !contains(userAgent, 'Chrome', true) && !contains(userAgent, 'Android', true);
  var isIOS = contains(userAgent, 'iPhone', true) || contains(userAgent, 'iPad', true);
  return isSafari || isIOS;
}
//region block: exports
export {
  maybeSafariOrIos as maybeSafariOrIos3eb7nhtdbwd99,
};
//endregion

//# sourceMappingURL=iosCheck.js.mjs.map
